<template>
  <div class="page">
    <div class="public-wrap">
      <h1>{{ $t('sign_up') }}</h1>
      <div class="cards">
        <router-link to="/register/school" class="card">
          <div class="icon-stage">
            <span class="icon-disk">
              <role-icon kind="school" />
            </span>
          </div>
          <h2>{{ $t('school') }}</h2>
        </router-link>
        <router-link to="/register/family" class="card">
          <div class="icon-stage">
            <span class="icon-disk">
              <role-icon kind="family" />
            </span>
          </div>
          <h2>{{ $t('public_cta_family') }}</h2>
        </router-link>
        <router-link to="/register/driver" class="card">
          <div class="icon-stage">
            <span class="icon-disk">
              <role-icon kind="driver" />
            </span>
          </div>
          <h2>{{ $t('public_cta_driver') }}</h2>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import RoleIcon from '@/components/RoleIcon.vue'
export default {
  components: { RoleIcon },
}
</script>
<style scoped>
.page { padding: 48px 0 80px; font-family: var(--font); }
.public-wrap { width: min(1080px, calc(100% - 32px)); margin: 0 auto; }
h1 { margin: 0 0 28px; font-size: 2.2rem; letter-spacing: -0.03em; color: var(--navy); }
.cards { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 22px; }
.card {
  display: block;
  background: var(--navy);
  border-radius: 24px;
  overflow: hidden;
  text-decoration: none;
  color: var(--white);
  box-shadow: var(--shadow);
}
.icon-stage {
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--navy);
}
.icon-disk {
  width: 168px;
  height: 168px;
  border-radius: 50%;
  background: var(--navy-2);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform .2s ease;
}
.card h2 { margin: 0; padding: 22px 24px 26px; font-size: 1.35rem; background: var(--white); color: var(--navy); }
.card:hover .icon-disk { transform: scale(1.04); }
</style>
